import { useContext } from 'react'
import ComponentDescription from '#/components/ComponentDescription'
import MapPreview from '#/components/MapPreview'
import ViewModeContext from '#/contexts/ViewMode'
import { commaNumber } from '#/utils/number'
import Hazards from '../Hazards/HazardRisks'
import Noise from '../Noise/NoiseLevel'
import Walkability from '../Walkability/WalkabilityIndex'
import { WeatherCard } from '../Weather'
import { Section } from '../common'

type EnvironmentProps = {
  property: TopHap.ExtendedProperty
}

const Environment: React.FC<EnvironmentProps> = ({ property }) => {
  const viewMode = useContext(ViewModeContext)
  const noise = property.noise ?
    property.noise.toFixed(0) :
    36

  const noisePrefix: string = property.noise ? '' : '<'

  return (
    <Section
      description={`Environmental factors around ${property.displayAddress}`}
      id='environment'
      title='Environment'
    >
      <Hazards property={property} />
      <Walkability property={property} />
      {/* // TODO: Need preview server */}
      {viewMode === 'PDF_FULL_PROPERTY' && (
        <ComponentDescription
          text='Walkability Index heatmap'
          width='20rem'
        >
          <MapPreview
            key='lot-walkability-item'
            className={viewMode === 'PDF_FULL_PROPERTY' ? 'rounded-l-none' : ''}
            height='22rem'
            label='walkability'
            // mapType={viewMode === 'PDF_FULL_PROPERTY' ? 'color' : 'satellite'}
            // metric='walkability'
            previewHeight={352}
            previewWidth={320}
            property={property}
            showMarker
            unit=''
            value={property.walkability !== null ?
              commaNumber(property.walkability, { maximumFractionDigits: 0 }) :
              undefined}
            zoom={viewMode === 'PDF_FULL_PROPERTY' ? 6 : 5}
          />
        </ComponentDescription>
      )}
      {property.noise && <Noise property={property} />}
      {/* // TODO: Need preview server */}
      {viewMode === 'PDF_FULL_PROPERTY' && property.noise && (
        <ComponentDescription
          text='Noise level heatmap'
          width='20rem'
        >
          <MapPreview
            className={viewMode === 'PDF_FULL_PROPERTY' ? 'rounded-l-none' : ''}
            height='22rem'
            label='noise'
            // mapType={viewMode === 'PDF_FULL_PROPERTY' ? 'color' : 'satellite'}
            // metric='noise'
            previewHeight={352}
            previewWidth={320}
            property={property}
            showMarker
            unit='dB'
            value={
              noisePrefix +
          commaNumber(noise, { maximumFractionDigits: 2 })
            }
            zoom={viewMode === 'PDF_FULL_PROPERTY' ? 6 : 5}
          />
        </ComponentDescription>
      )}
      <WeatherCard
        className='inline-flex h-[22rem] w-80 snap-center flex-col overflow-hidden rounded-xl bg-white py-2 align-top shadow-md'
        property={property}
      />
    </Section>
  )
}

export default Environment
